export const validNumberRegex = /^[0-9]*$/;

export const validUserIdRegex = /^([0-9][,]?)+$/;
export const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const validPhone = /^(([+]{0,1}\d{2})|\d?)[\s-]?[0-9]{2}[\s-]?[0-9]{3}[\s-]?[0-9]{4}$/;

export const timeRegex = /^([0-2][0-3]|[0-1][0-9])([0-9]|[0-5][0-9])?$/;
